import React from 'react';
import { useGeologyStore } from '../stores/useGeologyStore';
import { Gem, Clock, Tag, Hash, Loader2, AlertCircle, Layers } from 'lucide-react';

export const GeologyPanel: React.FC = () => {
  const unitCode = useGeologyStore((s) => s.unitCode);
  const unitName = useGeologyStore((s) => s.unitName);
  const rockGroup = useGeologyStore((s) => s.rockGroup);
  const stratAge = useGeologyStore((s) => s.stratAge);
  const stratName = useGeologyStore((s) => s.stratName);
  const isLoading = useGeologyStore((s) => s.isLoading);
  const error = useGeologyStore((s) => s.error);

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 rounded-lg bg-slate-800/50 px-3 py-2 text-xs text-slate-400">
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
        Fetching geology…
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center gap-2 rounded-lg bg-red-900/20 px-3 py-2 text-xs text-red-300 border border-red-800/30">
        <AlertCircle className="h-3.5 w-3.5 shrink-0" />
        {error}
      </div>
    );
  }

  if (!unitName && !rockGroup) {
    return (
      <div className="flex flex-col gap-1.5 rounded-lg bg-slate-800/50 p-3 border border-slate-700/30">
        <h3 className="text-[10px] font-semibold uppercase tracking-wider text-slate-500 mb-0.5">Surface Geology</h3>
        <div className="flex items-center gap-2 text-xs text-slate-500">
          <AlertCircle className="h-3.5 w-3.5 shrink-0" />
          No mapped geology for this area
        </div>
      </div>
    );
  }

  const items = [
    { label: 'Unit', value: unitName || 'Unknown', icon: <Tag className="h-3.5 w-3.5" /> },
    { label: 'Group', value: rockGroup || 'Unknown', icon: <Gem className="h-3.5 w-3.5" /> },
    { label: 'Age', value: stratAge || 'Unknown', icon: <Clock className="h-3.5 w-3.5" /> },
    { label: 'Strat', value: stratName || 'Unknown', icon: <Layers className="h-3.5 w-3.5" /> },
    { label: 'Code', value: unitCode || 'N/A', icon: <Hash className="h-3.5 w-3.5" /> },
  ];

  return (
    <div className="flex flex-col gap-1.5 rounded-lg bg-slate-800/50 p-3 border border-slate-700/30">
      <h3 className="text-[10px] font-semibold uppercase tracking-wider text-slate-500 mb-0.5">
        Surface Geology
      </h3>
      {items.map((item) => (
        <div key={item.label} className="flex items-center gap-2 text-xs">
          <span className="text-slate-500 shrink-0">{item.icon}</span>
          <span className="text-slate-400 shrink-0">{item.label}:</span>
          <span className="text-slate-200 truncate">{item.value}</span>
        </div>
      ))}
    </div>
  );
};
